module.exports = __webpack_public_path__ + "static/img/select-circle.8415edaa.png";